import { Controller } from '@hotwired/stimulus'

// Live "N / max caractères" counter for the subscription modal message textarea.
export default class extends Controller {
  static targets = ['input', 'count']

  connect() {
    this.update()
  }

  update() {
    this.countTarget.textContent = this.inputTarget.value.length
  }
}
